// WhatsApp share helper — India-first emotional copy
// Used on: CreateTripPage success modal, TripPage header share, post-confirmation invite

const formatDateRange = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const startStr = start.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
  const endStr = end.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  return `${startStr} – ${endStr}`;
};

export const buildTripShareMessage = (trip, tripLink) => {
  return `I locked my spot for ${trip.trip_name}

Destination: ${trip.destination}
Dates: ${formatDateRange(trip.start_date, trip.end_date)}

₹${trip.advance_amount} advance to confirm your seat.

Trip rules, refund policy, and details are inside:

${tripLink}

Only lock your spot if you're genuinely coming.`;
};

export const openWhatsAppShare = (trip, tripLink) => {
  const message = buildTripShareMessage(trip, tripLink);
  const url = `https://wa.me/?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};
